"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "m15.293 7.993-4.2929 4.2929-2.293-2.2929-1.4141 1.4142L11 15.1143l5.7071-5.707L15.293 7.993z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c-1.5556 1.0323-3.1926 1.85-5.0285 2.256-1.028.2274-1.9417.2667-2.9715.2667v7.5204c0 1.6625.321 3.5267 1.5328 4.9843C7.3105 19.1657 9.7223 20.4885 12 22c2.2777-1.5115 4.6895-2.8343 6.4672-4.9726C19.679 15.5698 20 13.7056 20 12.0431V4.5227c-1.0298 0-1.9436-.0393-2.9715-.2667C15.1926 3.85 13.5556 3.0323 12 2zM6 12.0431V6.4493a14.5141 14.5141 0 0 0 1.4035-.2405c1.2628-.2793 2.9091-.811 4.5965-1.826 1.6874 1.015 3.3337 1.5467 4.5965 1.826A14.5134 14.5134 0 0 0 18 6.4493v5.5938c0 1.4549-.2895 2.7661-1.0707 3.7057-1.5175 1.8252-3.4637 2.9418-4.9293 3.8625-1.4656-.9207-3.4118-2.0373-4.9293-3.8625C6.2895 14.8092 6 13.498 6 12.0431z"
  })];
};

exports.default = _default;